// TODO: Delete this file. All redirects now go to /status/[sessionId]
'use client';
import { Icon } from '@stone-payments/jade';

import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { usePaymentResponse } from '@payments-checkout/shared/providers';
import { useEffect } from 'react';
import { Replace } from '../../app/components/replace';
import { CopyButton } from '../copyButton/copyButton';
import { Success } from '../paymentStatus';

export function PixSuccess() {
  const { paymentResponse } = usePaymentResponse();

  const pixData = paymentResponse?.pix

  useEffect(() => {
    if (pixData) {
      analiticaInstance.events.pixPage.pageViewed();
    }
  }, [pixData]);

  if (!paymentResponse) return <Replace />;

  if (!pixData) throw new Error('Pix payment not found');

  const { qr_code_url, qr_code } = pixData;

  const sendAmplitudeEvent = () =>
    analiticaInstance.events.pixPage.copyClicked();

  return (
    <Success
      icon={<Icon use="qrcode" color="medium" size="xlarge" />}
      title="Pagar com pix"
      subtitle="Pague sua compra com o QR Code, que só é válido pelo tempo indicado."
      image={
        <img src={qr_code_url} className="w-[200px] h-[200px] mb-jade-100" />
      }
      paymentLine={qr_code}
    >
      {qr_code && (
        <div className="w-full flex">
          <CopyButton textToCopy={qr_code} onCopy={sendAmplitudeEvent}>
            Copiar QR Code
          </CopyButton>
        </div>
      )}
    </Success>
  );
}
